import React from 'react';
const IframeManager = ({ videoId }) => {
    const removeUrlEnding = () => {
        console.log("videoId.removeUrlEnding():", videoId);
        const searchValue = '/XLSharedApp_Iframe';
        return videoId.replace(searchValue, '');
    };
    return (React.createElement("iframe", { id: "sharedVideoPlayer", allowFullScreen: true, 
        // allowTransparency={true}
        // sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-downloads allow-modals"
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", title: "NVC Shared App", width: "100%", height: "100%", src: removeUrlEnding(), loading: "lazy" }));
};
export default IframeManager;
